"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var button_1 = require("@kaizen/button");
var chevron_down_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/chevron-down.icon.svg"));
var meatballs_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/meatballs.icon.svg"));
var draft_menu_1 = require("@kaizen/draft-menu");
var TitleBlockMenuItem_1 = require("./TitleBlockMenuItem");
var Toolbar_1 = __importDefault(require("./Toolbar"));
var TitleBlockZen_module_scss_1 = __importDefault(require("./TitleBlockZen.module.scss"));
var renderSecondaryOverflowMenu = function (secondaryOverflowMenuItems, reversed) {
    if (!secondaryOverflowMenuItems)
        return undefined;
    return (react_1["default"].createElement(draft_menu_1.Menu, { align: "right", button: react_1["default"].createElement(button_1.IconButton, { label: "Open secondary menu", reversed: reversed, icon: meatballs_icon_svg_1["default"] }) },
        react_1["default"].createElement(draft_menu_1.MenuList, null, secondaryOverflowMenuItems.map(function (menuItem, i) { return (react_1["default"].createElement(TitleBlockMenuItem_1.TitleBlockMenuItem, __assign({ key: i }, menuItem))); }))));
};
// Unfortunately, you'll notice below, that I needed to use the array index,
// against react best practices (https://reactjs.org/docs/lists-and-keys.html)
// This is because the menu items have no unique identifier.
var SecondaryActions = function (_a) {
    var secondaryActions = _a.secondaryActions, secondaryOverflowMenuItems = _a.secondaryOverflowMenuItems, _b = _a.reversed, reversed = _b === void 0 ? false : _b;
    if (!secondaryActions && !secondaryOverflowMenuItems)
        return null;
    var secondaryActionsAsToolbarItems = secondaryActions
        ? secondaryActions.map(function (action, i) {
            if ("menuItems" in action) {
                return {
                    key: "".concat(i),
                    node: (react_1["default"].createElement(draft_menu_1.Menu, { align: "right", button: react_1["default"].createElement(button_1.Button, { secondary: true, label: action.label, reversed: reversed, icon: chevron_down_icon_svg_1["default"], iconPosition: "end" }) },
                        react_1["default"].createElement(draft_menu_1.MenuList, null, action.menuItems.map(function (menuItem, i2) { return (react_1["default"].createElement(TitleBlockMenuItem_1.TitleBlockMenuItem, __assign({ key: i2 }, menuItem))); }))))
                };
            }
            else {
                if ("onClick" in action && "href" in action) {
                    // eslint-disable-next-line no-console
                    console.warn("\u001b[33m \nTITLE BLOCK WARNING:\nSecondary actions only support " +
                        "either an href or an onClick, not both simultaneously.\n");
                }
                return {
                    key: "".concat(i),
                    node: (react_1["default"].createElement(button_1.Button, __assign({ secondary: true, reversed: reversed }, action, { "data-automation-id": "title-block-secondary-actions-button", "data-testid": "title-block-secondary-actions-button" })))
                };
            }
        })
        : [];
    var overflowMenu = renderSecondaryOverflowMenu(secondaryOverflowMenuItems, reversed);
    var toolbarItems = __spreadArray(__spreadArray([], secondaryActionsAsToolbarItems, true), (overflowMenu
        ? [
            {
                key: "overflowMenu",
                node: overflowMenu
            },
        ]
        : []), true);
    return (react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].secondaryActionsContainer },
        react_1["default"].createElement(Toolbar_1["default"], { items: toolbarItems, noGap: true, automationId: "title-block-secondary-actions-toolbar" })));
};
exports["default"] = SecondaryActions;
//# sourceMappingURL=SecondaryActions.js.map